/*
 * MMC: ActiveCampaign newsletter form (see snippets/activecampaign-form.liquid).
 *
 * ActiveCampaign answers the JSONP request by calling window._show_thank_you(id, message) or
 * window._show_error(id, message, html), where "id" is the form ID. Forms are looked up by their "_form_{id}_" id.
 */
(() => {
  if (window.__suitActiveCampaignForm) {
    return;
  }

  window.__suitActiveCampaignForm = true;

  const getForm = (id) => document.getElementById(`_form_${id}_`);

  const showError = (form, message) => {
    const error = form.querySelector('.ac-form__error');
    error.textContent = message;
    error.hidden = !message;
  };

  window._show_thank_you = (id, message) => {
    const form = getForm(id);

    if (!form) {
      return;
    }

    const thankYou = form.querySelector('.ac-form__thank-you');
    form.querySelector('.ac-form__content').hidden = true;
    thankYou.innerHTML = message;
    thankYou.hidden = false;
  };

  window._show_error = (id, message) => {
    const form = getForm(id);

    if (!form) {
      return;
    }

    form.querySelector('.ac-form__submit').disabled = false;
    showError(form, new DOMParser().parseFromString(message, 'text/html').body.textContent);
  };

  const validate = (form) => {
    const email = form.elements.email.value.trim();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return form.dataset.errorEmail;
    }

    if (!form.querySelector('input[name="field[3]"]:checked')) {
      return form.dataset.errorGender;
    }

    if (!form.elements['field[4]'].value) {
      return form.dataset.errorDate;
    }

    return '';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-ac-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    const error = validate(form);
    showError(form, error);

    if (error) {
      return;
    }

    const submit = form.querySelector('.ac-form__submit');
    submit.disabled = true;

    const script = document.createElement('script');
    script.src = `${form.action}?${new URLSearchParams(new FormData(form)).toString()}&jsonp=true`;
    script.onerror = () => {
      submit.disabled = false;
      showError(form, form.dataset.errorNetwork);
    };
    script.onload = () => script.remove();
    document.head.appendChild(script);
  });
})();
